module.exports = __webpack_public_path__ + "static/img/10042.41f62ea7.png";